<template>
    <table v-if="orders.length" class="control-table orders-table">
        <thead class="control-table__head">
            <tr class="control-table__row">
                <th style="width: 25%" class="control-table__cell">
                    <div class="control-table__cell-inner">
                        {{ $t('crm.orders.list.title') }}
                    </div>
                </th>
                <th class="control-table__cell">
                    <div class="control-table__cell-inner orders-table__cell">
                        {{ $t('crm.orders.list.author') }}
                        <!-- <TableSorting v-model="ordering" field="author" /> -->
                    </div>
                </th>
                <th style="width: 8%" class="control-table__cell">
                    <div class="control-table__cell-inner orders-table__cell">
                        {{ $t('crm.orders.list.voice') }}
                        <!-- <TableSorting v-model="ordering" field="speaker" /> -->
                    </div>
                </th>
                <th style="width: 12%" class="control-table__cell">
                    <div class="control-table__cell-inner orders-table__cell">
                        {{ $t('crm.orders.list.lastChange') }}
                        <TableSorting v-model="ordering" field="modified" />
                    </div>
                </th>
                <th v-if="isInnerWorkspace" class="control-table__cell">
                    <div class="control-table__cell-inner orders-table__cell">
                        {{ $t('crm.orders.list.customer') }}
                        <TableSorting v-model="ordering" field="customer" />
                    </div>
                </th>
                <th v-if="isInnerWorkspace" class="control-table__cell">
                    <div class="control-table__cell-inner orders-table__cell">
                        {{ $t('crm.orders.list.type') }}
                        <TableSorting v-model="ordering" field="type_productions" />
                    </div>
                </th>
                <th class="control-table__cell">
                    <div class="control-table__cell-inner orders-table__cell">
                        {{ $t('crm.orders.list.state') }}
                        <!-- <TableSorting v-model="ordering" field="state" /> -->
                    </div>
                </th>
            </tr>
        </thead>
        <tbody class="control-table__body">
            <tr v-for="order in orders" :key="order.id" class="control-table__row">
                <td class="control-table__cell">
                    <router-link :to="`/orders/${order.id}`">
                        <b>{{ order.details.name }}</b>
                    </router-link>
                    <span class="badge" style="margin-left: 1em">{{ order.order_type }}</span>
                </td>
                <td class="control-table__cell">
                    {{ getAuthorsFullNames(order.details.raw_authors) }}
                </td>
                <td class="control-table__cell">
                    {{ order.speaker && order.speaker.name[$i18n.locale] }}
                </td>
                <td class="control-table__cell">
                    {{ formatDate(order.modified, { locale: $i18n.locale }) }}
                </td>
                <td v-if="isInnerWorkspace" class="control-table__cell">
                    {{ order.customer.name }}
                </td>
                <td v-if="isInnerWorkspace" class="control-table__cell">
                    {{ order.type_productions }}
                </td>
                <td class="control-table__cell">
                    <OrderStatusBadge v-if="order.state.label" compact>
                        {{ order.state.label[$i18n.locale] }}
                    </OrderStatusBadge>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import OrderStatusBadge from '../OrderStatusBadge/OrderStatusBadge';
import TableSorting from '@speechki-frontend/shared/ui/TableSorting';
import { mapGetters } from 'vuex';
import { formatDate } from '@speechki-frontend/shared/helpers/functions';

export default {
    name: 'OrdersTable',
    components: {
        OrderStatusBadge,
        TableSorting,
    },
    props: {
        orders: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            ordering: '-id',
        };
    },

    computed: {
        ...mapGetters('workspaces', ['isInnerWorkspace']),
    },

    watch: {
        ordering() {
            this.$emit('sort', this.ordering);
        },
    },

    methods: {
        formatDate,
        getAuthorsFullNames(authors) {
            if (!authors || !authors.length) return '';

            return authors.map((author) => author.full_name).join(', ');
        },
    },
};
</script>

<style src="./OrdersTable.scss" lang="scss"></style>
